export const Mic = ({ solid = false }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={solid && "#2E1500"}
        d="M21 8C21 5.23858 18.7614 3 16 3C13.2386 3 11 5.23858 11 8V16C11 18.7614 13.2386 21 16 21C18.7614 21 21 18.7614 21 16V8Z"
        stroke="#2E1500"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 25V29"
        stroke="#2E1500"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.95 17C24.6905 19.1915 23.6361 21.2116 21.9865 22.6774C20.3369 24.1433 18.2068 24.9529 16 24.9529C13.7932 24.9529 11.6631 24.1433 10.0135 22.6774C8.3639 21.2116 7.30943 19.1915 7.04999 17"
        stroke="#2E1500"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Ripples = () => (<svg width="390" height="333" viewBox="0 0 390 333" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M195 388.934C302.107 388.934 388.934 302.107 388.934 195C388.934 87.893 302.107 1.06557 195 1.06557C87.893 1.06557 1.06557 87.893 1.06557 195C1.06557 302.107 87.893 388.934 195 388.934ZM195 390C302.696 390 390 302.696 390 195C390 87.3045 302.696 0 195 0C87.3045 0 0 87.3045 0 195C0 302.696 87.3045 390 195 390ZM195 323.934C266.208 323.934 323.934 266.208 323.934 195C323.934 123.791 266.208 66.0656 195 66.0656C123.791 66.0656 66.0656 123.791 66.0656 195C66.0656 266.208 123.791 323.934 195 323.934ZM195 325C266.797 325 325 266.797 325 195C325 123.203 266.797 65 195 65C123.203 65 65 123.203 65 195C65 266.797 123.203 325 195 325ZM281.311 195C281.311 242.669 242.669 281.311 195 281.311C147.331 281.311 108.689 242.669 108.689 195C108.689 147.331 147.331 108.689 195 108.689C242.669 108.689 281.311 147.331 281.311 195ZM282.377 195C282.377 243.257 243.257 282.377 195 282.377C146.743 282.377 107.623 243.257 107.623 195C107.623 146.743 146.743 107.623 195 107.623C243.257 107.623 282.377 146.743 282.377 195ZM195 270.778C236.851 270.778 270.778 236.851 270.778 195C270.778 153.15 236.851 119.223 195 119.223C153.15 119.223 119.223 153.15 119.223 195C119.223 236.851 153.15 270.778 195 270.778ZM195 272C237.526 272 272 237.526 272 195C272 152.475 237.526 118.001 195 118.001C152.475 118.001 118.001 152.475 118.001 195C118.001 237.526 152.475 272 195 272ZM259.212 195.001C259.212 230.464 230.464 259.212 195.001 259.212C159.538 259.212 130.789 230.464 130.789 195.001C130.789 159.538 159.538 130.789 195.001 130.789C230.464 130.789 259.212 159.538 259.212 195.001ZM260.38 195.001C260.38 231.109 231.109 260.38 195.001 260.38C158.893 260.38 129.622 231.109 129.622 195.001C129.622 158.893 158.893 129.622 195.001 129.622C231.109 129.622 260.38 158.893 260.38 195.001Z" fill="url(#paint0_radial_299_12858)" />
  <defs>
    <radialGradient id="paint0_radial_299_12858" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(195 190.5) rotate(90) scale(130 240.537)">
      <stop offset="0.166999" stop-color="white" />
      <stop offset="0.70445" stop-color="white" stop-opacity="0.04" />
    </radialGradient>
  </defs>
</svg>
)

export const ArrowRight = () => (<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg>)

export const OverlayRectangle = () => (<svg width="490" height="844" viewBox="0 0 390 844" fill="none" xmlns="http://www.w3.org/2000/svg">
<g style={{
"mix-blend-mode": "soft-light"
}} >
<path d="M-140.464 -110L-474 109.038L125.144 839.367C131.812 847.496 140.508 853.72 150.353 857.412L151.254 857.75C184.11 877.662 337.437 934.413 532.58 692.476C683.916 479.411 636.126 335.046 571.41 294.225L-140.464 -110Z" fill="url(#paint0_linear_1340_1814)"/>
</g>
<defs>
<linearGradient id="paint0_linear_1340_1814" x1="22.8191" y1="258.382" x2="330.468" y2="559.062" gradientUnits="userSpaceOnUse">
<stop stop-color="white"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
)